import React from 'react';
import '../PasswordExpiry/PasswordExpiryPopUp.css';
import closeIcon from '../assets/icons/close_white.png';
import warningIcon from '../assets/icons/warning-yellow.svg';
import { api } from '../utils';
type Props = {
	msg: string;
	onClickClose: Function;
};
const PasswordExpiryPopUp = ({ msg, onClickClose }: Props) => {
	const agentId = sessionStorage.getItem('agentId');

	document.addEventListener('click', (e: Event) => {
		const el: any = e.target;
		const clsList: any = el.classList;
		if (clsList[0] !== 'popUp') {
			onClickClose(e);
		}
	});

	const closeNotification = () => {
		api('updateNotificationSeen', 'POST', { seen: true, userId: agentId })
			.then((data) => {
				sessionStorage.setItem('notify', 'false');
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const redirectToSetNewPassword = () => {
		window.open('/ResetPassword/?userId=' + agentId, '_blank');
		// window.location.href = "/AwareHybridChat/ResetPassword?userId=" + agentId;
	};

	return (
		<div className='expiry-popup' onClick={redirectToSetNewPassword}>
			<div className='warning'>
				<div className='icon'>
					<img src={warningIcon} alt='warning' />
				</div>
			</div>
			<div className='expiry-message'>
				<div className='text'>{msg}</div>
				<div className='reset-link' onClick={redirectToSetNewPassword}>
					Click here to reset it
				</div>
			</div>
			<div
				className='cross-mark'
				onClick={(e) => {
					closeNotification();
					onClickClose(e);
				}}>
				<img src={closeIcon} alt='close' />
			</div>
		</div>
	);
};

export default PasswordExpiryPopUp;
